<template>
  <div class="simulation-active-menu" v-if="simulation != null">
    <simulation-menu class="mb-2" />
    <simulation-round-list />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SimulationMenu from "@editor/items/simulation/SimulationMenu.vue";
import SimulationRoundList from "@editor/items/simulationRound/RoundList.vue";

import { useSimulationViewStore } from "@editor/views/simulation/simulationView.store";

const simulationViewStore = useSimulationViewStore();

const simulation = computed(() => simulationViewStore.simulation);
</script>

<style>
.simulation-active-menu {
  height: 100%;
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: min-content minmax(0, 1fr);
}
</style>
